export const abhaCardDetailsTranslations = {
    en: {
        personalDetails: "Personal Details",
        healthCamp: "Health Camp:",
        beneficiaryName: "Beneficiary Name:",
        fullName: "Full Name:",
        gender: "Gender:",
        dateOfBirth: "Date of Birth:",
        mobileNumber: "Mobile Number:",
        email: "Email:",
        aadhaarNo: "Aadhaar No:",
        drivingLicense: "Driving License:",
        identificationType: "Identification Type:",
        guardianName: "Guardian Name:",
        pincode: "Pincode:",
        address: "Address:",
        taluka: "Taluka:",
        district: "District:",

        testTypesAndRemarks: "Test Types & Remarks",
        remarks: "Remarks:",
        noRemarksProvided: "No remarks provided",
        notAvailable: "N/A"
    },
    mr: {
        personalDetails: "वैयक्तिक तपशील",
        healthCamp: "आरोग्य शिबिर:",
        beneficiaryName: "लाभार्थीचे नाव:",
        fullName: "पूर्ण नाव:",
        gender: "लिंग:",
        dateOfBirth: "जन्मतारीख:",
        mobileNumber: "मोबाईल नंबर:",
        email: "ईमेल:",
        aadhaarNo: "आधार क्रमांक:",
        drivingLicense: "ड्रायव्हिंग लायसन्स:",
        identificationType: "ओळख प्रकार:",
        guardianName: "पालकाचे नाव:",
        pincode: "पिन कोड:",
        address: "पत्ता:",
        taluka: "तालुका:",
        district: "जिल्हा:",

        testTypesAndRemarks: "चाचणी प्रकार आणि शेरा",
        remarks: "शेरा:",
        noRemarksProvided: "कोणतीही टिप्पणी दिली नाही",
        notAvailable: "उपलब्ध नाही"
    }
};
